export const PaymentMethod = {
  CreditCard: 'CreditCard',
  Paypal: 'Paypal',
  AdyenCreditCard: 'AdyenCreditCard',
  ACH: 'ACH',
};

/**
 * @typedef {'CreditCard'|'Paypal'|'AdyenCreditCard'|'ACH'} PaymentMethod
 */
